// extracted by mini-css-extract-plugin
module.exports = {"singleResourcePage":"view_singleResourcePage__j5L1b g-grid-container","pageLane":"view_pageLane__jsUtq","contentLane":"view_contentLane__Bdya1"};